
<div class="container my-3 p-3 General container-fluid">
  <h3>{{ "EServicesAccountUpgrades.Title" | translate }}</h3>
  <div [innerHTML]="'EServicesAccountUpgrades.Text' | translate: links"></div>

  <p>
    <a href="https://res.cloudinary.com/los-angeles-county-assessor/image/upload/v1790363825/What%27s%20new%20e-services/Assessor_e-Services_Account_Registration_System_2.0_-_What_s_New.pdf" target="_blank">{{ "EServicesAccountUpgrades.WhatsNewPdf" | translate }}</a>
  </p>
</div>
